import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Maybe } from '@graphql-tools/utils/typings/types';
import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { buildTimestampDate, buildTimestampTime } from '../../helpers/formatters';
import {
  Resource_AppointmentMsg,
  Resource_AppointmentStatus,
} from '../../src/generated/graphql';
import styles from './appointment-request.module.scss';
import { LinkedAppointmentCancelledTag } from "../appointments/linked-appointment-cancelled-tag";

interface AppointmentRequestAppointmentsProps {
  clinicId: Maybe<string> | undefined;
  appointments: Maybe<(Maybe<Resource_AppointmentMsg> | undefined)[]> | undefined;
}

export const AppointmentRequestAppointments: FC<AppointmentRequestAppointmentsProps> = ({
  appointments,
  clinicId,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  return appointments && appointments.length > 0 ? (
    <Card>
      <Title level={3} style={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'appointment-request.appointments' })}
      </Title>
      <div>
        {appointments.map((appointment) => (
          <div
            key={appointment?.id}
            className={styles.appointment}
            onClick={() =>
              router.push({
                pathname: '/appointments/appointment',
                query: {
                  appointmentId: appointment?.id,
                  clinicId: clinicId,
                },
              })
            }
          >
            <span>
              <CalendarOutlined /> {buildTimestampDate(appointment?.startTime)}
            </span>
            <span className={styles.appointmentTime} style={{ marginLeft: 20 }}>
              <ClockCircleOutlined /> {buildTimestampTime(appointment?.startTime)}
            </span>
            {appointment?.appointmentStatus ===
              Resource_AppointmentStatus.AppointmentStatusCancelled && (
              <span style={{ float: "right" }}>
                <LinkedAppointmentCancelledTag
                  singleAppointment
                  showIcon={false}
                />
              </span>
            )}
          </div>
        ))}
      </div>
    </Card>
  ) : null;
};
